// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__10Lry","right":"Footer_right__efuxQ","buttons":"Footer_buttons__IYNjn"};